
import { MessagesService } from "@/services/messages-service";
import { EmailTemplateInfo } from "@/utils/email-template-info";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppPurchaseInboxreaderSettings from "@/components/settings-sales/PurchaseInboxreaderSettings.vue";

export default Vue.extend({
	data() {
		return{
			templates: [] as EmailTemplateInfo[],
		};
	},
	computed: {
		path():IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("sale/purchase")
				},
				{
					value: this.$ct("mails")
				}
			] as IBreadCrumb[];
		}
	},
	methods: {
		addNew() {
			this.$router.push("/settings/sales/mail-template/new");
		},
		editTemplate(template: EmailTemplateInfo) {
			this.$router.push("/settings/sales/mail-template/edit/" + template.ID);
		},
		async copyTemplate(template:EmailTemplateInfo) {
			let tmpl = await MessagesService.getSaleTemplate(template.ID);
			tmpl.ID = 0;
			tmpl.Name = tmpl.Name + " " + this.$ct("common.copy-noun");
			await MessagesService.postSaleTemplates([tmpl]);
			await this.fetch();
		},
		async deleteTemplate(template: EmailTemplateInfo) {
			let confirmText = this.$ct("template-delete-confirm", {template: template.Name});
			let warningText = this.$ct("common.warning");
			let yesText = this.$ct("common.yes");
			let noText = this.$ct("common.no");
			let confirmed = await this.$wf.confirm(confirmText, yesText, noText, warningText, "warning");
			if (!confirmed) return;
			await MessagesService.deleteSaleTemplates(template);
			await this.fetch();

		},
		async fetch(){
			this.templates = await MessagesService.getSaleTemplates();
		},
		async onSorted(){
			await MessagesService.setSaleTemplateOrder(this.templates);
		}
	},
	async mounted() {
		await this.fetch();
	},
	components: {
		AppPurchaseInboxreaderSettings
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
